import client from './client';
import { AdminSummary } from '../types';

export const getAdmins = async (): Promise<AdminSummary[]> => {
  const response = await client.get<AdminSummary[]>('/admins');
  return response.data;
};
